import { CircularProgress, IconButton, InputAdornment } from "@mui/material";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";

export function PasteIntoAdornment(props: { onClick(): void; disabled: boolean }) {
  return (
    <InputAdornment position="start">
      <IconButton edge="start" onClick={props.onClick} disabled={props.disabled}>
        <ContentPasteGoIcon />
      </IconButton>
    </InputAdornment>
  );
}

export function pasteIntoSlotProps(opts: { loading: boolean; disabled: boolean }, onClick: () => void) {
  return {
    input: {
      startAdornment: opts.loading ? (
        <InputAdornment position="start">
          <CircularProgress size={20} />
        </InputAdornment>
      ) : (
        <PasteIntoAdornment onClick={onClick} disabled={opts.disabled} />
      ),
    },
  };
}
